import React from 'react';

import { Box } from '@mui/material';
import NavBar from 'components/NavBar';

export default function MainLayout({ children }: React.PropsWithChildren) {
  return (
    <Box display="flex" flexGrow={1}>
      <NavBar />
      <Box
        sx={{
          bgcolor: 'background.default',
          flexBasis: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
